import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { User } from "chipster-js-common";
import { RestErrorService } from "../../../core/errorhandler/rest-error.service";
import { AuthenticationService } from "../../../core/authentication/authentication-service";

@Component({
  selector: "ch-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.less"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class UsersComponent implements OnInit {
  users: User[];

  constructor(
    private restErrorService: RestErrorService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.users = [];

    this.authenticationService.getUsers().subscribe({
      next: (users: User[]) => {
        this.users = users;
      },
      error: (err) => this.restErrorService.showError("get users failed", err),
    });
  }
}
